<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="复制" fontSize="14px"
				:useAutoOptional="false" :optional="sbmidarr.length !== 1" @btnclick="copy"
				:src="require('@/assets/icon/icon-copy.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px"
				:useAutoOptional="false" :optional="sbmidarr.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" :useAutoOptional="false"
				:optional="sbmidarr.length !== 1" @btnclick="Look"
				:src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="$emit('Export')"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="customerImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" v-if="qx.add" @click="SeconDowload">导入模版下载</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="comtable" @handleSelectionChange="handleSelectionChange"
				@onRowClick="onRowClick" colnum="7" :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="550px" :title="EidtTitle" :dialogVisible="dialogVisibles" @cancel="dialogVisibles = false"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist ref="addjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
						:pt="item.pt" :options="item.options" @remoteMethod="remoteMethodtows" :key="index"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:event="item.event" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max" :checkboxdata="item.checkboxdata" :multiple="item.multiple"
						:disabled="item.disabled" @invClass="getLEVEL3List()">
					</Commondropdownlist>
				</template>
				<div style="margin-top:24px;">
					<Commontable v-if="tableModelData.length" ref="modeltable" :loadingTable="false"
						@handleSelectionChange="(e)=>CusCodeDetails = e.map(it => it.CusCode)" colnum="7"
						:tableData="tableModelData" :headerData="modelData" height="100%">
					</Commontable>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%" />
			</div>
		</DialogFrom>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import fromdata from "../fromData/add";
	import Dialog from "../../../../components/dialog.vue";
	import CommonbtnUpLoad from "../../../../components/common-upload.vue";
	import headerData from "../tableData/headerData";
	import modelData from "../tableData/modelData";
	import utils from "../../../../common/utils";

	import {
		GetOrganizationRebateInfo,
		AddOrganizationRebate,
		EditOrganizationRebate,
		DeleteOrganizationRebate,
		DownloadOrganizationRebateTemplet,
		ImportOrganizationRebate,
		GetHelperLevel3,
		GetOrderCustomer
	} from "@/api/newsapi";

	import {
		InventoryClassList
	} from '@/api/home'

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonbtnUpLoad,
		},
		props: {
			tableData: {
				type: Array,
				default: [],
			},
			total: {
				type: Number,
				default: 0,
			}
		},
		data: function() {
			return {
				sbmidarr: [],
				dialogVisibles: false,
				dialogVisibledel: false,
				dialogVisiblesdrjg: false,
				fromdataadd: [],
				tableDatadrjg: [],
				cusinfo: null,
				cusId: "",
				title: "",
				EidtTitle: "",
				headerData: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					browse: false
				},
				modelData: [],
				tableModelData: [],
				CusCodeDetails: [],
			}
		},
		mounted() {
			this.headerData = JSON.parse(JSON.stringify(headerData));
			this.modelData = JSON.parse(JSON.stringify(modelData));
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
			this.QX();
			this.getProductLineList();
		},
		methods: {
			handleSelectionChange(val) {
				this.sbmidarr = val.map(it => it.ID);
				this.cusId = val.length === 1 ? val[0].ID : "";
			},
			onRowClick(val) {
				this.cusId = val.ID;
			},
			// 获取产品线列表
			async getProductLineList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.fromdataadd[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.fromdataadd[0].options.push(obj)
					})
				}
			},
			// 根据产品线获取LEVEL3列表
			async getLEVEL3List(invClass) {
				let {
					code,
					data
				} = await GetHelperLevel3({
					InvClass: invClass ? invClass : this.$refs.addjxa[0].modelvalue
				});
				if (code == 0) {
					if (!invClass) {
						this.$refs.addjxa[1].modelvalue = '';
					}
					this.fromdataadd[1].options = [];
					data.map((item, index) => {
						this.fromdataadd[1].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			// 经销商下拉搜索
			async remoteMethodtows(query) {
				let {
					code,
					data
				} = await GetOrderCustomer({
					CusName: query
				});
				if (code == 0) {
					this.fromdataadd[2].options = data.map(item => ({
						key: item.CusCode,
						value: item.CusName
					}));
				}
			},
			// 查看
			Look() {
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.EidtTitle = "查看";
				this.dialogVisibles = true;
				this.customerInfo();
			},
			//添加
			adduser() {
				this.cusId = '';
				this.dialogVisibles = true;
				this.EidtTitle = "新增";
				this.$nextTick(() => {
					this.$refs.comtable.$refs.multipleTable.setCurrentRow('');
				})
			},
			// 复制
			copy() {
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.dialogVisibles = true;
				this.EidtTitle = "新增";
				this.customerInfo();
			},
			// 修改
			update() {
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.dialogVisibles = true;
				this.EidtTitle = "编辑";
				this.customerInfo();
			},
			del() {
				if (!this.sbmidarr.length) {
					this.$message.error("请选择要删除的数据！");
					return;
				}
				this.dialogVisibledel = true;
			},
			async dialogOKdel() {
				let {
					code,
					message
				} = await DeleteOrganizationRebate({
					IDs: this.sbmidarr,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功",
					});
					this.sbmidarr = [];
					this.canceldel();
					this.$parent.customerList();
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			canceldel() {
				this.dialogVisibledel = false;
			},
			// 详情
			async customerInfo() {
				let {
					code,
					data
				} = await GetOrganizationRebateInfo({
					ID: this.cusId,
				});
				if (code == 0) {
					this.$refs.addjxa[0].modelvalue = data.InvClass;
					this.getLEVEL3List(data.InvClass);
					this.$nextTick(() => {
						this.$refs.addjxa[1].modelvalue = data.LEVEL3;
						this.$refs.addjxa[2].modelvalue = data.CusCode;
						this.fromdataadd[2].options = [{
							key: data.CusCode,
							value: data.CusName
						}];
						this.$refs.addjxa[3].modelvalue = data.RebateRatio;
						this.$refs.addjxa[4].modelvalue = data.StartDate;
						this.$refs.addjxa[5].modelvalue = data.EndDate;
					});
					this.$forceUpdate();
				}
			},
			//弹窗提交
			async dialogOK() {
				if (this.EidtTitle == "查看") {
					this.dialogVisibles = false;
				} else if (this.EidtTitle == "新增") {
					let {
						code,
						message
					} = await AddOrganizationRebate({
						InvClass: this.$refs.addjxa[0].modelvalue,
						LEVEL3: this.$refs.addjxa[1].modelvalue,
						CusCode: this.$refs.addjxa[2].modelvalue,
						RebateRatio: this.$refs.addjxa[3].modelvalue,
						StartDate: this.$refs.addjxa[4].modelvalue,
						EndDate: this.$refs.addjxa[5].modelvalue
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "新增成功",
						});
						this.$parent.customerList();
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
						this.dialogVisibles = false;
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				} else {
					let {
						code,
						message
					} = await EditOrganizationRebate({
						ID: this.cusId,
						InvClass: this.$refs.addjxa[0].modelvalue,
						LEVEL3: this.$refs.addjxa[1].modelvalue,
						CusCode: this.$refs.addjxa[2].modelvalue,
						RebateRatio: this.$refs.addjxa[3].modelvalue,
						StartDate: this.$refs.addjxa[4].modelvalue,
						EndDate: this.$refs.addjxa[5].modelvalue
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "修改成功",
						});
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
						this.cusId = '';
						this.$parent.customerList();
						this.dialogVisibles = false;
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				}
			},
			handleCurrentChange(pageindex) {
				this.$emit("handleCurrentChange", pageindex);
			},
			handleSizeChange(paegSzie) {
				this.$emit("handleSizeChange", paegSzie);
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1085) {
								this.qus = items.Nodes;
							}
						});
					}
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "browse") {
							this.qx.browse = true;
						}
					});
				}
			},
			// 下载导入模板
			async SeconDowload() {
				let {
					data,
					code,
					message
				} = await DownloadOrganizationRebateTemplet({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message,
					});
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			// 导入
			async customerImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)",
					});
					let formData = new FormData();
					formData.append("file", file);
					let res = await ImportOrganizationRebate(formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message,
						});
						this.$parent.customerList();
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message,
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						loading.close();
					}
					loading.close();
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			}
		},
		watch: {
			dialogVisibles: {
				handler(val) {
					if (!val) {
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
					}
				},
				deep: true,
			},
			EidtTitle: {
				handler(newVal, oldVal) {
					if (newVal == "查看") {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = true;
						});
					} else {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = false;
						});
					}
				},
			},
		},
	};
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.line {
			width: 100%;
			height: 1px;
			background: #eaecef;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
			margin-top: 30px;
		}

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.Code {
		width: 100%;
	}

	.type {
		width: 98.6%;
		border: 1px solid #e6e6e6;
		font-size: 17px;
		color: #333333;
		font-weight: 500;
		padding: 10px 10px 10px 0;
		margin: 0 auto;

		.type-top {
			width: 100%;
			border-bottom: 1px solid #e6e6e6;
			font-weight: bold;
			color: #333333;
			font-size: 14px;
			text-indent: 16px;
			line-height: 16px;
			padding-bottom: 10px;

			.type-top-left {
				width: 3px;
				height: 16px;
				display: inline-block;
				background-color: #e71d43;
				float: left;
			}
		}

		.type-text {
			margin-top: 12px;
		}

		.CodeText {
			display: inline-block;
			width: 430px;
			margin-left: 30px;
			font-size: 14px;
			font-weight: 500;
			// border: 1px solid red;
			color: #999999;
			margin-top: 12px;
			position: relative;

			.imgBox {
				display: inline-block;
				width: 96px;
				height: 96px;
				border: 1px solid #e6e6e6;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}

			span {
				display: inline-block;
				color: #333333;
				font-weight: 500;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}
		}
	}

	.LicenseRfrom {
		width: 100%;
		height: 500px;
		overflow: scroll;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}

	.imgTop {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 75px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop2 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 145px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop3 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 175px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop4 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 130px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}
</style>
